export class Teamlistmodule {
    constructor() {
        this.addImageLiquid();
        this.properties();
        this.scrollToTargetAdjusted();

        if ($("#component-teamlist-carousel").length > 0) {            
            this.loadCarousel();
        } 

        this.buildHeaderContentLinks()
    }

    properties() {
        this.sliderSelector = "#component-teamlist-carousel .consultant-carousel__slider";
        this.slidesToShow = 1;
        this.slidesToScroll = 1;
        this.initialSlide = 0;
    }

    loadCarousel() {
        this.loadSlick()
    }


    loadSlick() {

        var _this = this;
        $(this.sliderSelector).slick({
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 0,
                    settings: {
                        dots: true,
                        infinite: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        initialSlide: _this.initialSlide,
                        arrows: false
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        dots: true,
                        infinite: true,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        arrows: true
                    }
                }
            ]
        });

    }

    buildHeaderContentLinks() {
        var links = {};
        links.items = [];
        
        var els = $(".section-text__content strong");
        var cp = $("#meettheteam");
        els = els.add(cp);

        if (els.length > 0) {
            $.each(els, function (index, el) {
                var linkName = "pageContent" + index;
                els[index].setAttribute("id", linkName);

                links.items.push({
                    name: linkName,
                    title: els[index].innerText
                });
            });

            var rowObj = $(".container-component__hero")[0].children[0];
            var output = "<div class='row'><div class='col-sm-12'><hr><h4 class='medium'>On this page:</h4><ul class='hero-link-ul' style=''>";
            $.each(links.items, function (index, l) {
                var link = "<a href='#" + links.items[index].name + "' class='scrolltolink'>" + links.items[index].title + "</a>";
                //output += "<li class='hero-link'>" + link + "&nbsp;|&nbsp;</li>";
                output += "<li class='hero-link'>" + link + "</li>";
            });
            output += "</ul></div></div>";
            $(rowObj).append(output);
        }

    }

    addImageLiquid() {
        $('.consultant-listing__item__image--cropped').imgLiquid({
            horizontalAlign: '74%'
        });
    }  

    scrollToTargetAdjusted() {
        $(".container-component__hero").on("click", ".scrolltolink", function (e) {

            e.preventDefault();
            var $window = $(window);

            var link = $(this).attr("href").replace("#","");

            var element = document.getElementById(link);
            var headerOffset = 140;
            var windowsize = $window.width();
            if (windowsize > 500) {
                headerOffset = 200;
            }

            //console.log(windowsize);

            var elementPosition = element.getBoundingClientRect().top;
            var offsetPositon = elementPosition - headerOffset;
            window.scrollTo({
                top: offsetPositon,
                behavior: "smooth"
            });
            
        });
    }
}





